@if (toasts().length) {
  <div class="toast-container" role="region" aria-live="assertive" aria-atomic="true">
    @for (toast of toasts(); track toast.id) {
      <div class="toast" [ngClass]="'toast--' + toast.type" role="alert">
        <span class="toast__icon" aria-hidden="true">{{ icons[toast.type] }}</span>
        <p class="toast__message">{{ toast.message }}</p>
        <button
          type="button"
          class="toast__close"
          (click)="onDismiss(toast.id)"
          [attr.aria-label]="'shared.toast.closeAria' | t"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    }
  </div>
}
